__turbopack_context__.v({
  "loaderWrapper": "styles-module__LN9z3a__loaderWrapper",
  "mainWrapper": "styles-module__LN9z3a__mainWrapper",
});
